import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
    const maxSpacePerSlide = 500;
    const minSpacePerSlide = 200;
    const media = gsap.matchMedia();

    const spacePerSlide = function () {
        return Math.min(
            maxSpacePerSlide,
            Math.max(
                minSpacePerSlide,
                window.innerHeight - $.constants.menuHeight
            )
        );
    };

    media.add(
        "(min-width: 992px) and (prefers-reduced-motion: no-preference)",
        function () {
            const wrappers = $(".tpl-slides").children(".wrapper");
            const allSlides = wrappers.find(".slide");

            $(".tpl-slides").each(function () {
                const section = this;
                const wrapper = $(section).children(".wrapper").first();
                const slides = wrapper.find(".slide");
                const total = slides.length;

                if (wrapper.length === 0 || total === 0) {
                    return;
                }

                const distance = function () {
                    return (
                        spacePerSlide() * (total + 1) + $.constants.menuHeight
                    );
                };

                const update = function (self) {
                    const active = Math.min(
                        total,
                        Math.floor(
                            (self.progress * distance()) / spacePerSlide()
                        ) + 1
                    );

                    slides.each(function (index) {
                        $(this)
                            .toggleClass("shown", index < active)
                            .toggleClass(
                                "hidden",
                                index + 1 !== active &&
                                    index < active &&
                                    index < total - 1
                            );
                    });
                };

                ScrollTrigger.create({
                    trigger: section,
                    start: function () {
                        return `top top+=${$.constants.menuHeight}`;
                    },
                    end: function () {
                        return `+=${distance()}`;
                    },
                    pin: wrapper.get(0),
                    anticipatePin: 1,
                    invalidateOnRefresh: true,
                    refreshPriority: $.refreshPriority(section),
                    onToggle: function (self) {
                        wrapper.toggleClass("fixed", self.isActive);
                    },
                    onUpdate: update,
                    onRefresh: update,
                });
            });

            return function () {
                allSlides.removeClass("shown").removeClass("hidden");
                wrappers.removeClass("fixed");
            };
        }
    );

    media.add(
        "(min-width: 992px) and (prefers-reduced-motion: reduce)",
        function () {
            const slides = $(".tpl-slides").find(".slide").addClass("shown");

            return function () {
                slides.removeClass("shown");
            };
        }
    );
});
